import {View, Text, Image} from '@react-pdf/renderer';
import styles from '../styles';
import {COLORS, PERFORMANCE_UNITS} from '../constants';
import mapIcon from '../../../assets/image/pdf/map_icon.svg';
import cultivationIcon from '../../../assets/image/pdf/cultivation_icon.svg';
import leafIcon from '../../../assets/image/pdf/leaf_icon.svg';
import moneyIcon from '../../../assets/image/pdf/money_icon.svg';
import {fixRtlNumberStart, getShamsiDate} from '../utils/formatData';

export default function CultivationInfoCard({
  cultivationArea,
  cultivationCase,
  estimatedPerformance,
  estimatedPrice,
  album,
  name,
  cultivationImage,
  performanceUnit = 'ton',
}: {
  cultivationArea: string;
  cultivationCase: string;
  estimatedPerformance: string;
  estimatedPrice?: string;
  album: {imageUrl: string; date: string}[];
  name: string;
  cultivationImage?: string;
  performanceUnit: string;
}) {
  return (
    <View wrap={false} style={styles.section}>
      <View
        style={[styles.sectionCard, {direction: 'rtl', textAlign: 'right'}]}
      >
        <Text style={{fontSize: 12}}>کشت {name}</Text>
        <View style={styles.mainCultivationCardSection}>
          <View style={styles.mainCultivationPhoto}>
            <View
              style={{
                width: 142,
                height: 142,
                backgroundColor: COLORS.textMuted,
                borderRadius: 8,
                overflow: 'hidden',
              }}
            >
              <Image
                source={cultivationImage}
                style={{width: '100%', height: '100%'}}
              />
            </View>
          </View>
          <View style={{}}>
            <Text
              style={{alignSelf: 'flex-end', fontSize: 12, marginBottom: 16}}
            >
              اطلاعات کشت {name}
            </Text>
            <View style={styles.mainCultivationInfo}>
              <View style={{width: 120}}>
                <View style={{display: 'flex', flexDirection: 'row-reverse'}}>
                  <View style={{height: 16, width: 16, marginLeft: 4}}>
                    <Image source={mapIcon} />
                  </View>
                  <Text style={{color: COLORS.textSecondary, marginBottom: 8}}>
                    سطح زیر کشت
                  </Text>
                </View>
                <View style={{display: 'flex', flexDirection: 'row-reverse'}}>
                  <View style={{height: 16, width: 16, marginLeft: 4}}>
                    <Image source={cultivationIcon} />
                  </View>
                  <Text style={{color: COLORS.textSecondary, marginBottom: 8}}>
                    وضعیت کشت
                  </Text>
                </View>
                <View style={{display: 'flex', flexDirection: 'row-reverse'}}>
                  <View style={{height: 16, width: 16, marginLeft: 4}}>
                    <Image source={leafIcon} />
                  </View>
                  <Text style={{color: COLORS.textSecondary, marginBottom: 8}}>
                    پیش‌بینی عملکرد
                  </Text>
                </View>
                <View style={{display: 'flex', flexDirection: 'row-reverse'}}>
                  <View style={{height: 16, width: 16, marginLeft: 4}}>
                    <Image source={moneyIcon} />
                  </View>
                  <Text style={{color: COLORS.textSecondary, marginBottom: 8}}>
                    پیش‌بینی قیمت
                  </Text>
                </View>
              </View>

              <View style={{width: 200, direction: 'rtl'}}>
                <Text style={{marginBottom: 8}}>
                  {fixRtlNumberStart(cultivationArea)}
                </Text>
                <Text style={{marginBottom: 8}}>{cultivationCase}</Text>
                <Text style={{marginBottom: 8}}>
                  {fixRtlNumberStart(
                    `${estimatedPerformance} ${PERFORMANCE_UNITS[performanceUnit]}`,
                  )}
                </Text>
                <Text style={{marginBottom: 8}}>
                  {!!estimatedPrice
                    ? fixRtlNumberStart(`${estimatedPrice} تومان`)
                    : '-'}
                </Text>
              </View>
            </View>
          </View>
        </View>

        <Text style={{fontSize: 12, marginVertical: 10}}>
          تصاویر سبزینگی کشت
        </Text>
        <View style={styles.cultivationAlbumWrapper}>
          {album.slice(0, 6).map(item => (
            <View style={styles.cultivationAlbumItem}>
              <View style={{width: '100%', marginBottom: 4}}>
                <View
                  style={{
                    width: '100%',
                    height: 64,
                    backgroundColor: COLORS.textMuted,
                    borderRadius: 3,
                    overflow: 'hidden',
                  }}
                >
                  <Image source={item.imageUrl} />
                </View>
              </View>
              <Text>{getShamsiDate(new Date(item.date))}</Text>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
}
